import { mapCountryCodeToDefaultCurrency } from '@seek/salary-data';

import type { EmployerSiteName } from 'src/config';

export const getSiteCurrency = (site: EmployerSiteName) => {
  const country = site.split('-')[2];

  return mapCountryCodeToDefaultCurrency(country);
};
